module.exports = __webpack_public_path__ + "static/img/m_5.162d0e4b.jpg";